import { useRef } from 'react';
import { useC3Chart } from '../../hooks/useC3Chart';
import type { LabelValue } from '../../utilities/chartData';

// c3's default category10 palette — keeps bar colours in sync with pie slice colours
const C3_COLORS = [
  '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728',
  '#9467bd', '#8c564b', '#e377c2', '#7f7f7f',
  '#bcbd22', '#17becf',
];

interface Props {
  data: LabelValue[];
  onItemClick?: (label: string) => void;
}

export function BarChartPanel({ data, onItemClick }: Props) {
  const chartRef = useRef<HTMLDivElement>(null);
  const onItemClickRef = useRef(onItemClick);
  onItemClickRef.current = onItemClick;

  useC3Chart(chartRef, () => {
    if (!data.length) return null;
    return {
      data: {
        columns: [['count', ...data.map(d => d.value)]],
        type: 'bar',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color: (_color: string, d: any) =>
          C3_COLORS[(typeof d === 'object' ? d.index : 0) % C3_COLORS.length],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onclick: (d: any) => onItemClickRef.current?.(data[d.index]?.label),
      },
      axis: {
        rotated: true,
        x: {
          type: 'category',
          categories: data.map(d => d.label),
          tick: { multiline: false },
        },
        y: {
          tick: { format: (v: number) => v.toLocaleString() },
        },
      },
      bar: { width: { ratio: 0.6 } },
      legend: { show: false },
    };
  }, [data]);

  return <div ref={chartRef} />;
}
